import React from "react";
import {MessageReference} from "../../../../../m3/_legacy_components/notifications";

export function WB_MessagesReply({}) {
    return <div>
       <MessageReference />
    </div>
}